import type { ProductNode } from "./types";

export const renderProductItems = (products: ProductNode[]) => {
  return products
    .map((product) => {
      const productUrl = `/products/${product.handle}`;

      return `
      <div class="product-groups__item swiper-slide">
        <div class="product-groups__item-image">
          <a href="${productUrl}" aria-label="${product.title}">
            <img src="${product.featuredImage?.url}" alt="${product.featuredImage?.altText}">
          </a>
        </div>

        <div class="product-groups__item-title">
          ${product.title}
        </div>
      </div>
    `;
    })
    .join("");
};
